var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.info)?_c('div',{staticClass:"info-message mx-4"},[_c('v-alert',{attrs:{"width":"300","type":_vm.info.type,"data-test":"alertMessage","dismissible":""},on:{"input":_vm.close},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v(" "+_vm._s(_vm._f("translate")(_vm.info.message))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }